import StoredLayout from '../../layouts/StoredLayout'
import Images from './Images'
export default StoredLayout(Images)



// WEBPACK FOOTER //
// ./src/ui-elements/images/index.js